import type { RichWhisperProps } from '@frontend/react-domain';
import { VendorContactPhoneWhisper } from './VendorContactPhoneWhisper';
import { withWhisperAccordion } from './withWhisperAccordion';

const PhoneAccordion = withWhisperAccordion(VendorContactPhoneWhisper);
const TitleOnly = withWhisperAccordion();

export const VendorContactWhisper = (props: RichWhisperProps) => {
  const { whisper } = props;
  const hasPhoneStats =
    whisper.type === 'vendor_contact' && (whisper.durationSec !== undefined || whisper.holdDurationSec !== undefined);
  return hasPhoneStats ? <PhoneAccordion {...props} /> : <TitleOnly {...props} />;
};
